import { useEffect, useState } from "react";
import { useForm, Controller } from 'react-hook-form'
import DatePicker from "react-multi-date-picker";
import moment from 'moment/moment';

import Modal from '../Modal';
import { createProject, getProject, updateProject } from "../../api/project.api";
import { showSuccess, showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";

export function ProjectModal({projectId, closeAction }) {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const[project, setProject] = useState({})
    const {category, refreshProjectsCategory} = CategoryData();

    const getProjectError = error => {
        setProject({})
        showError(`Error al recuperar el projecto. ${error.message}`)
    }

    useEffect(() => {
        async function loadProject() {
            if(projectId){
                const res = await getProject(projectId,getProjectError)
                setProject(res.data)
                setValue('name', res.data.name)
                setValue('richDescription', res.data.richDescription)
                setValue('deadline', new Date(res.data.deadline))
            }else{
                setValue('deadline', new Date(moment().add(1,'M').add(1,'days')))
            }
        }
  
        loadProject()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        closeAction()
    };

    const actionBar = (
        <div className="flex">
            <button className=' bg-blue-400 rounded-md block w-10 hover:bg-blue-500' onClick={handleClose}>X</button>
        </div>
    )
    const renderHeader = () => {
        if(category){
            return(<h1 className='font-bold text-2xl'>{category.name} - Agregar proyecto</h1>)
        }else{
            return(<h1 className='font-bold text-2xl'>Editar proyecto</h1>)
        }
    }
    

    const handleSave = handleSubmit(async data => {
        if(category && category.id){
            const payload = {
                name: data.name,
                richDescription: data.richDescription,
                deadline: moment(new Date(data.deadline)).format('YYYY-MM-DD'),
                categoryId: category.id
            }
            await createProject(payload, createProjectSuccess, createProjectError)
        }
    })
    const handleUpdate = handleSubmit(async data => {
        if(projectId){
            const payload = {
                name: data.name,
                richDescription: data.richDescription,
                deadline: moment(new Date(data.deadline)).format('YYYY-MM-DD')
            }
    
            await updateProject(projectId, payload, updateProjectSuccess, updateProjectError)
        }
    })

    const createProjectSuccess = (res => {
        showSuccess('Proyecto creado')
        refreshProjectsCategory(category)
        handleClose()
    })

    const createProjectError = (error => {
        showError(`Error al crear el proyecto. ${error.message}. ${error.response.data}`)
    })

    const updateProjectSuccess = (res => {
        showSuccess('Proyecto actualizado')
        refreshProjectsCategory(category)
        handleClose()
    })

    const updateProjectError = (error => {
        showError(`Error al actualizar el proyecto. ${error.message}. ${error.response.data}`)
    })

    const renderButton = () => {
        if(!projectId)
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Crear</button>)
        else
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleUpdate}>Actualizar</button>)
    }

    const modal = <Modal onClose={handleClose} actionBar={actionBar} header={renderHeader} modalSize={'52'}>
        <div className='mt-3 grid grid-cols-3 '>
            <div className='col-span-3 ml-2'>
                <form action="" >
                    <div className="flex">
                        <input
                            type="text"
                            placeholder="Nombre"
                            {...register("name", { required: true })}
                            className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                        />
                        {errors.name && <span>Campo requerido</span>}

                        <div className="flex flex-col">
                        <div className="ml-2 h-6">Posible deadline</div>
                        <Controller
                            control={control}
                            name="deadline"
                            rules={{ required: true }}
                            render={({
                                field: { onChange, name, value },
                                fieldState: { invalid, isDirty },
                                formState: { errors },
                            }) => (
                                <>
                                    <DatePicker
                                        value={value || ""}
                                        onChange={(date) => {
                                            onChange(date?.isValid ? date : "");
                                        }}
                                        format={"DD/MM/YYYY"}
                                        inputClass=' bg-blue-100 rounded-lg ml-2'
                                    />
                                </>
                            )}
                        />
                        {errors.deadline && <span className='font-bold text-red-500'>Fecha de exp. es requerido</span>}
                        </div>
                    </div>

                    <textarea
                        rows="3"
                        placeholder="Descripción"
                        {...register("richDescription", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.richDescription && <span>Campo requerido</span>}

                </form>
                {renderButton()}
            </div>
        </div>
    </Modal>

    return (
        <div>
            {modal}
        </div>
    )
}